import React from "react";

import { Box, Flex, Grid, GridItem, Icon } from "@chakra-ui/react";
import { BsCheckCircle, BsChevronRight, BsExclamationTriangle } from "react-icons/bs";

import { putComunicacion } from "api/comunicaciones";
import IndiceIndicator from "common/components/IndiceIndicator";
import { PortfolioDateInput } from "common/components/PortfolioDateInput";
import { PortfolioInfoLine } from "common/components/PortfolioInfoLine";
import { ActivoCompletoOutput } from "components/Portfolio/types/activos";
import { actions as portfolioActions } from "store/portfolio/reducer";
import { useAppDispatch, useAppSelector } from "store/store";

import { BotonComunicaciones } from "./Comunicaciones";
interface IProps {
	asset: ActivoCompletoOutput;
	onOpenComunicaciones: (asset: ActivoCompletoOutput) => void;
}

export const ComunicacionesRow: React.FC<IProps> = (props) => {
	const { asset } = props;
	const dispatch = useAppDispatch();
	const features = useAppSelector((state) => state.user.features.data);
	const hasAddCommentFeature = features.indexOf("add-comment") >= 0 && !!asset.comunicacion_id;

	const onChangeRevisedAt = async (date: Date | undefined) => {
		if (!asset.comunicacion_id) return;
		const updated = await putComunicacion({
			id: asset.comunicacion_id,
			data: { revised_at: date?.toISOString() || "" },
		});
		dispatch(portfolioActions.editarComunicacionActivo({ assetId: asset.id, comunicacion: updated.data }));
	};

	const onChangeResponseDate = async (date: Date | undefined) => {
		if (!asset.comunicacion_id) return;
		const updated = await putComunicacion({
			id: asset.comunicacion_id,
			data: { response_date: date?.toISOString() || "" },
		});
		dispatch(portfolioActions.editarComunicacionActivo({ assetId: asset.id, comunicacion: updated.data }));
	};

	return (
		<Box p=".5rem 0" rounded="md" bgColor="white" mt=".5rem" pl="1rem" h="2.5rem">
			<Flex height="100%" alignItems="center">
				<Grid templateColumns="repeat(18, 1fr)" w="100%" color="gray.800" alignItems="center">
					<GridItem colSpan={1} pt=".5rem" pl="1.5rem">
						{asset.por_validar === undefined || asset.por_validar ? (
							<Icon as={BsExclamationTriangle} color="red.500" fontSize="1.25rem" />
						) : (
							<Icon as={BsCheckCircle} color="green.500" fontSize="1.25rem" />
						)}
					</GridItem>
					<GridItem data-testid="assetName" colSpan={4}>
						<PortfolioInfoLine value={asset.nombre} href={`/activo/${asset.id}/portada/${asset.ite_id}`} />
					</GridItem>
					{asset && (
						<React.Fragment>
							<GridItem colSpan={2}>
								{asset.nec_indice && <IndiceIndicator indice={asset.nec_indice.toLocaleString()} />}
							</GridItem>
							<GridItem colSpan={2}>
								<PortfolioDateInput
									column="revised_at"
									value={asset.revised_at}
									editable={hasAddCommentFeature}
									onChange={(d) => onChangeRevisedAt(d)}
									placeholder={"Sin comunicación"}
								/>
							</GridItem>
							<GridItem colSpan={2}>
								<PortfolioInfoLine
									value={
										asset.type === "mail_manual"
											? "Mail manual"
											: asset.type === "mail_plataforma"
											? "Mail plataforma"
											: asset.type === "telefono"
											? "Teléfono"
											: asset.type
									}
								/>
							</GridItem>
							<GridItem colSpan={2}>
								<PortfolioInfoLine value={asset.recipients?.join(", ")} />
							</GridItem>
							<GridItem colSpan={2}>
								<PortfolioDateInput
									column="response_date"
									value={asset.response_date}
									editable={hasAddCommentFeature}
									onChange={(d) => onChangeResponseDate(d)}
									placeholder={"Sin comunicación"}
								/>
							</GridItem>
							<GridItem colSpan={2}>
								<BotonComunicaciones onOpenComunicaciones={() => props.onOpenComunicaciones(asset)} />
							</GridItem>
						</React.Fragment>
					)}
				</Grid>
				<Icon as={BsChevronRight} color="gray.600" width="1rem" height="1rem" mr="1rem" />
			</Flex>
		</Box>
	);
};
